<template>
    <div>
        <div v-if="tabs.length > 1" class="-mr-8 lg:mr-0">
            <div class="max-w-full overflow-auto scrollbar-hide w-full pr-8 lg:pr-0">
                <div class="inline-flex flex-nowrap my-10 border border-gray rounded-mid py-2 px-1.5">
                    <div v-for="tab in tabs"
                         :key="tab._uid"
                         @click="activate(tab)"
                         class="px-15 py-3 text-sm whitespace-nowrap transition-colors cursor-pointer select-none rounded-mid hover:text-black"
                         :class="[tab.active ? 'bg-white text-black' : 'text-gray']">
                        <span class="kicker !p-0 !bg-transparent">
                            {{ tab.title }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div :style="maxHeight" class="lg:cheight">
            <slot/>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop, Provide } from 'vue-property-decorator';
import Tab from './Tab.vue';

@Component
export default class Tabs extends Vue {
    @Provide('registerTab') childRegistration = this.register;

    @Prop({ default: false }) editMode: boolean;

    tabs: Tab[] = [];
    height = 0;

    mounted() {
        window.addEventListener('resize', this.onResize);
    }

    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    }

    register(tab: Tab, height: number) {
        this.tabs.push(tab);
        // set height to the highest tab to prevent jumping
        if (height > this.height) {
            this.height = height;
        }

        if (this.$children.filter(this.filterItems).length === this.tabs.length) {
            this.tabs.forEach((tab, i) => {
                tab.active = i === 0;
            });
        }
    }

    // check children to only count tab components
    filterItems(child: Vue) {
        return child.$vnode && child.$vnode.componentOptions && child.$vnode.componentOptions.tag === 'slct-tab';
    }

    activate(tab: Tab) {
        if (tab.active) {
            return;
        }
        this.tabs.forEach(t => {
            t.active = false;
        });
        tab.active = true;
    }

    // update tabs height on window resize
    onResize() {
        this.height = this.tabs.reduce((max, tab: Tab) => Math.max(max, tab.content.clientHeight), 0);
    }

    get maxHeight() {
        return {
            '--custom-height': (this.editMode || this.tabs.length < 2) ? 'auto' : `${this.height}px`
        };
    }
}
</script>
